// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__26Zzz","title":"InfoRow_title__2-qzo"};